import React from "react";
import Select from "react-select";

export const CustomSelect = ({
  placeholder,
  field,
  form,
  options,
  isMulti = false,
  handleDistrictInForm,
  getPrimaryContactForSouthRgn,
  disabled,
  onClickHandler,
  makeActiveDistList,
  isAddMode,
  isViewMode,
  pmcDistrictData,
  paaDistrictData
}) => {
  const onChange = (option= isMulti ? [] : {}) => {
    if(handleDistrictInForm){
      let status = []
      if(form.values?.Region === 'Plains - North'){
        status = [...pmcDistrictData].map(item => item.IsActive)
      }
      if(form.values?.Region === 'Plains - South'){
        status = [...paaDistrictData].map(item => item.Active)
      }
      /** 
       * Editing an outage which doesn't have PinId and it's dropdown district values 
       * contains both active and non-active values then only
       * - Clear district dropdown
       * - Clear Facility dropdown
       * - Renew district dropdown values with active ones only
       */
      if(!form?.values?.PindId && !isAddMode && !isViewMode && status.includes(false)){
        form.setFieldValue('District', form.values?.Region === 'Plains - North' ? '' : [])
        form.setFieldValue('Facility', form.values?.Region === 'Plains - North' ? '' : [])
        makeActiveDistList(form?.values?.Region)
      }
      handleDistrictInForm(option, form.values)
      if(form?.values?.Region === 'Plains - South'){
        form.setFieldValue('PrimaryContact', getPrimaryContactForSouthRgn(option))
      }
    }

    form.setFieldValue(
      field.name,
      isMulti
        ? option?.length ? option.map(item => item.value) : []
        : option?.value
    );
  };

const filterOption = (option, inputValue) => {
  const { label } = option;

  if (typeof label === 'string' && typeof inputValue === 'string') {

    const lowerCaseLabel = label.toLowerCase();
    const lowerCaseInputValue = inputValue.toLowerCase();

    const words = lowerCaseLabel.split(/\s+/);

    return words.some(word => word.startsWith(lowerCaseInputValue));
  }
  return false;
};

  const getValue = () => {
      // Check if field has value then try to grab from the provided options
    if (options?.length && field?.value) {
      const value = isMulti
      ? options.filter(option => {
       if(field.value.includes('; ')){
          return field.value.split('; ').includes(option.label)
          }
          return typeof field?.value === 'string' ? field.value.split(';').includes(option.value) : field.value.includes(option.value);
      })
      : options.find(option => option.value === field.value);
      return value
    } else {
      return isMulti ? [] : ''
    }
  };

  const onClick = async (event) => {
    if(onClickHandler && field?.name === 'Facility'){
      await onClickHandler(form.values, disabled)
    }else if(onClickHandler){
      await onClickHandler(form.values)
    }
  }

  /** Select doesn't have it's own onClick handler so, 
   * providing click functionality to Select by wrapping Select in div 
  */
  return (
    <div onClick={onClick}>
      <Select
        filterOption={filterOption}
        name={field.name}
        value={getValue()}
        onChange={onChange}
        placeholder={placeholder}
        options={options}
        isMulti={isMulti}
        isDisabled={disabled}
        classNamePrefix="custom-select"
      />
    </div>
  );
};

export default CustomSelect;
